import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from 'react-router';

import { AppShell } from './components/app-shell';
import { useAuth } from './hooks/use-auth';
import { AccountPage } from './pages/Account';
import { ClientDetailPage } from './pages/ClientDetail';
import { ClientsPage } from './pages/Clients';
import { InvoiceDetailPage } from './pages/InvoiceDetail';
import { InvoicesPage } from './pages/Invoices';
import { IntegrationsPage } from './pages/Integrations';
import { LoginPage } from './pages/Login';
import { OverviewPage } from './pages/Overview';
import { ProjectDetailPage } from './pages/ProjectDetail';
import { ProjectsPage } from './pages/Projects';
import { ReconciliationPage } from './pages/Reconciliation';
import { SettingsPage } from './pages/Settings';
import { UsagePage } from './pages/Usage';

function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <p className="p-6 text-sm text-slate-600">Loading session...</p>;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}

function LoginRoute() {
  const { user, loading } = useAuth();
  if (loading) {
    return <p className="p-6 text-sm text-slate-600">Loading session...</p>;
  }
  if (user) {
    return <Navigate to="/overview" replace />;
  }
  return <LoginPage />;
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginRoute />} />

        <Route element={<RequireAuth />}>
          <Route element={<AppShell />}>
            <Route index element={<Navigate to="/overview" replace />} />
            <Route path="/overview" element={<OverviewPage />} />
            <Route path="/clients" element={<ClientsPage />} />
            <Route path="/clients/:id" element={<ClientDetailPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/projects/:id" element={<ProjectDetailPage />} />
            <Route path="/invoices" element={<InvoicesPage />} />
            <Route path="/invoices/:id" element={<InvoiceDetailPage />} />
            <Route path="/reconciliation" element={<ReconciliationPage />} />
            <Route path="/integrations" element={<IntegrationsPage />} />
            <Route path="/usage" element={<UsagePage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/account" element={<AccountPage />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/overview" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
